import { Icon } from '@iconify/react';
import AnimatedSection from '../components/ui/AnimatedSection';
import PageBanner from '../components/layout/PageBanner';

export default function Soporte(){
    return(
        <main className="bg-[#f5f5f7] text-[#2d2d44]">
            <PageBanner
              titulo="Soporte"
              crumbs={[
                { label: 'Inicio', href: '/' },
                { label: 'Soporte' },
              ]}
            />
            <div className="max-w-4xl mx-auto px-4 py-12">
                <AnimatedSection className="max-w-lg mx-auto text-center">
                    <div className="w-16 h-16 rounded-2xl bg-[#f26724]/10 border border-[#f26724]/20 flex items-center justify-center mx-auto mb-6">
                        <Icon icon="mdi:headset" className="text-3xl text-[#f26724]" />
                    </div>
                    <h2 className="text-2xl font-bold text-[#f26724] mb-3">¿Necesitas ayuda?</h2>
                    <p className="text-gray-500 mb-8">Estamos aquí para ayudarte. Elige el canal de tu preferencia.</p>
                    <div className="space-y-4">
                        <a href="https://api.whatsapp.com/send?phone=51946564003&text=Necesito%20soporte%20t%C3%A9cnico" className="flex items-center justify-center gap-3 w-full px-8 py-4 bg-[#25D366] text-white font-semibold rounded-xl hover:bg-[#20bd5a] transition-all hover:shadow-lg hover:shadow-green-500/20" target="_blank" rel="noopener noreferrer">
                            <Icon icon="mdi:whatsapp" className="text-2xl" />
                            Soporte por WhatsApp
                        </a>
                        <a href="mailto:soporte@scalar.pe" className="flex items-center justify-center gap-3 w-full px-8 py-4 border-2 border-black/20 text-gray-600 font-semibold rounded-xl hover:bg-black/5 hover:border-black/40 transition-all">
                            <Icon icon="mdi:email" className="text-2xl" />
                            soporte@scalar.pe
                        </a>
                    </div>
                    <hr className="border-black/10 my-8" />
                    <div className="text-left space-y-4">
                        <h5 className="text-[#f26724] font-semibold text-center mb-4">Preguntas frecuentes</h5>
                        <details className="bg-white border border-black/10 rounded-xl p-4 group cursor-pointer">
                            <summary className="text-sm font-medium text-[#2d2d44] flex items-center justify-between">
                                ¿Cómo reinicio mi contraseña?
                                <Icon icon="mdi:chevron-down" className="text-gray-400 transition-transform group-open:rotate-180" />
                            </summary>
                            <p className="text-sm text-gray-500 mt-3 leading-relaxed">Puedes cambiar tu contraseña desde la opción "Cambiar contraseña" en el menú de usuario. Si no recuerdas tu contraseña actual, contacta a soporte.</p>
                        </details>
                        <details className="bg-white border border-black/10 rounded-xl p-4 group cursor-pointer">
                            <summary className="text-sm font-medium text-[#2d2d44] flex items-center justify-between">
                                ¿Cómo actualizo mis datos de perfil?
                                <Icon icon="mdi:chevron-down" className="text-gray-400 transition-transform group-open:rotate-180" />
                            </summary>
                            <p className="text-sm text-gray-500 mt-3 leading-relaxed">Ve a la sección "Perfil" desde el menú de usuario para ver y actualizar tu información personal.</p>
                        </details>
                        <details className="bg-white border border-black/10 rounded-xl p-4 group cursor-pointer">
                            <summary className="text-sm font-medium text-[#2d2d44] flex items-center justify-between">
                                Horarios de atención
                                <Icon icon="mdi:chevron-down" className="text-gray-400 transition-transform group-open:rotate-180" />
                            </summary>
                            <p className="text-sm text-gray-500 mt-3 leading-relaxed">Nuestro equipo de soporte está disponible de lunes a viernes de 9:00 a 18:00. Para atención urgente, escríbenos por WhatsApp.</p>
                        </details>
                    </div>
                </AnimatedSection>
            </div>
        </main>
    )
}
